import { Alert, Snackbar } from "@mui/material";
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import { createStyles, makeStyles, Theme, StylesProvider } from "@material-ui/core/styles";
import { config } from "../config/config";

interface Props {
  open: any
  onClose: any
  msg: string
}

export const MsgSnackbar = ({ open, onClose, msg }: Props) => {

  const useSnackbarClassStyles = makeStyles((theme: Theme) =>
    createStyles({
      done: {
        color: "#fff",
        backgroundColor: "#057F00"
      }
    })
  );
  const snackbarClass = useSnackbarClassStyles();
  return (
    <StylesProvider>
      <Snackbar 
        className={snackbarClass.done}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={open}
        autoHideDuration={config.snackbarDispTime}
        onClose={onClose}
        >
        <Alert
          className={snackbarClass.done} 
          severity="success" 
          sx={{ width: '100%', backgroundColor: '#057F00', color: '#fff' }} 
          onClose={onClose}
          iconMapping={{
            success: <CheckCircleOutline fontSize="inherit" className={snackbarClass.done} />,
          }}
          >
          {msg}
        </Alert>
      </Snackbar>
    </StylesProvider>
  );
}

export default MsgSnackbar;
